import {SignedOut, SignedIn, ClerkLoading} from "@clerk/nextjs";
// import {SignInLayout} from "../../layouts/SignInLayout";
import {SignInForm} from "../components/DemoSignInForm";
// import {SignUpLayout} from "../../layouts/SignUpLayout";
// import {SignUpForm} from "../components/SignUpForm";
import Layout from '../components/layout'
import { useRouter } from 'next/router'
import Container from '../components/Container';
import Head from 'next/head'
import {
  Flex,
  Heading,
  Text,
  Stack,
  Box,
  Spinner,
  useColorModeValue
} from '@chakra-ui/react';

const SignIn = () => {
  const borderColor = useColorModeValue("gray.200", "neutral.900")
  return (
    <Layout>
    <Head>
      <title>Sign In - Demo</title>
    </Head>
    <Container>

      <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            pt={50}
            pb={100}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            >
                  <ClerkLoading>
        <Spinner />
      </ClerkLoading>
        <SignedOut>
        <Stack spacing={8} mx={'auto'} maxW={'md'} minW={'md'} py={12} px={6}>
        <Stack align={'center'}>
        <Heading as="h1" fontSize={'2xl'}>Sign in to demo account</Heading>
          </Stack>
          <Box
          rounded={'lg'}
          bg={useColorModeValue('white', '#1A1E24')}
          // boxShadow={'lg'}
          borderColor={borderColor}
          borderWidth={'1px'}
          // minW="450"
          p={8}
          >
        <SignInForm />
        </Box>
        </Stack>
        </SignedOut>
        <SignedIn>
          <Text>You're signed in.</Text>
        </SignedIn>
        </Flex>
            </Container>
            </Layout>
    // </SignUpLayout>
  );
};

export default SignIn;